import type { TFunction } from "i18next";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";
import { STATIC_COURSE_ASSIGN_BROWSER_ROUTES } from "./browser.routes";
import { COURSE_ASSIGN_MENU_KEY, SPECIAL_INITIATIVE_COURSES_MENU_KEY } from "./menu.keys";
import { COURSE_ASSIGN_ACCESS_PERMISSIONS, SPECIAL_INITIATIVE_ACCESS_PERMISSIONS } from "./permissions";

/** Sidebar: Course Assignment (assign courses list). */
export function getCourseAssignMenuItem(t: TFunction) {
	return {
		key: COURSE_ASSIGN_MENU_KEY,
		label: t("layout.sidebar.menuName.courseAssign"),
		icon: <AssignmentOutlinedIcon fontSize="medium" />,
		route: STATIC_COURSE_ASSIGN_BROWSER_ROUTES.COURSE_ASSIGN,
		requiredAnyOfPermissions: [...COURSE_ASSIGN_ACCESS_PERMISSIONS],
	};
}

/** Sidebar: Special Initiative Courses (top-level). */
export function getSpecialInitiativeCoursesMenuItem(t: TFunction) {
	return {
		key: SPECIAL_INITIATIVE_COURSES_MENU_KEY,
		label: t("layout.sidebar.menuName.specialInitiativeCourses"),
		icon: <VolunteerActivismOutlinedIcon fontSize="medium" />,
		route: STATIC_COURSE_ASSIGN_BROWSER_ROUTES.SPECIAL_INITIATIVE,
		requiredAnyOfPermissions: [...SPECIAL_INITIATIVE_ACCESS_PERMISSIONS],
	};
}

/** @deprecated Use getCourseAssignMenuItem — kept for backward-compatible imports. */
export function getStaticCourseAssignMenuItem(t: TFunction) {
	return getCourseAssignMenuItem(t);
}
